// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/bg.css
// module id = 2003
// module chunks = 2